var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealWords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11719 8.26367H16.929",
    stroke: "#26445A",
    strokeOpacity: 0.4,
    strokeWidth: 1.88824,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2891 7.71777H21.3281",
    stroke: "#26445A",
    strokeOpacity: 0.4,
    strokeWidth: 2.51766,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11719 14.5576H16.929",
    stroke: "#26445A",
    strokeOpacity: 0.4,
    strokeWidth: 1.88824,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2891 14.5576H21.3281",
    stroke: "#26445A",
    strokeOpacity: 0.4,
    strokeWidth: 2.51766,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 20.8525H16.9368",
    stroke: "#26445A",
    strokeOpacity: 0.4,
    strokeWidth: 1.88824,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2891 21.3984H21.3281",
    stroke: "#26445A",
    strokeOpacity: 0.4,
    strokeWidth: 2.51766,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealWords);
export default __webpack_public_path__ + "static/media/REAL_WORDS.d690a40692ace3930176e515d44fa8c6.svg";
export { ForwardRef as ReactComponent };